export default __webpack_public_path__ + "static/media/project.3bbc8d89.png";